import React, { forwardRef, MutableRefObject } from 'react';
import { HStack, VStack } from 'native-base';
import { useTheme } from '@springbig/shared';
import { IVStackProps } from 'native-base/lib/typescript/components/primitives/Stack/VStack';

type PanelProps = IVStackProps & {
    children: React.ReactNode;
    row?: boolean;
};

export const Panel = forwardRef(
    ({
        children,
        row = false,
        ...props
    }: PanelProps, ref: MutableRefObject<HTMLDivElement>) => {

        const {
            panel,
            panel_text,
        } = useTheme();

        return (
            row ?
                <HStack
                    bg={panel}
                    color={panel_text}
                    p={4}
                    w={'100%'}
                    overflow={'clip'}
                    {...props}
                    ref={ref}
                >
                    { children }
                </HStack>
                :
                <VStack
                    bg={panel}
                    color={panel_text}
                    p={4}
                    w={'100%'}
                    overflow={'clip'}
                    {...props}
                    ref={ref}
                >
                    { children }
                </VStack>
        );
    });

Panel.displayName = 'Panel';

export default Panel;
